import ApiERP from '@/core/conectores/ApiERP';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ICacheFiltros } from '@/models/Relatorios/ICacheFiltros';

/**
 * Serviço de Relatório da DRE
 * Fornece todas regras de negócios e lógicas relacionado a DRE.
 */
class ServicoCacheFiltros {
  endPoint = 'cache-filtros';

  apiERP = new ApiERP();

  public requisicaoSistema():void {
    this.apiERP = new ApiERP(true);
  }

  public async incluirCacheFiltros(cache: ICacheFiltros): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.post(`${this.endPoint}`, cache);
    return result.data;
  }

  public async alterarCacheFiltros(cache: ICacheFiltros): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.put(`${this.endPoint}/${cache.codigo}`, cache);
    return result.data;
  }

  public async excluirCacheFiltros(codigo: number, empresa: number): Promise<IRetornoRequisicao> {
    const result: any = await this.apiERP.delete(`${this.endPoint}/${codigo}/empresa/${empresa}`);
    return result.data;
  }

  public async obterCacheFiltros(chave: string, empresa: number): Promise<ICacheFiltros> {
    const result: any = await this.apiERP.get(`${this.endPoint}/chave/${chave}/empresa/${empresa}`);
    return result.data;
  }

  public async obterCacheFiltrosPorUsuario(chave: string, empresa: number, usuario: number): Promise<ICacheFiltros> {
    const result: any = await this.apiERP.get(`${this.endPoint}/chave/${chave}/empresa/${empresa}/usuario/${usuario}`);
    return result.data;
  }
}
export default ServicoCacheFiltros;
